// src/components/data/quizzesStore.js

// Demo de cursos que tienen cuestionarios
export const questionnaireCourses = [
  {
    id: "curso-etica",
    titulo: "Código de Ética y Conducta",
    resumen: "Normatividad, cultura de cumplimiento y casos prácticos.",
    estado: "En curso",
    modulos: [
      {
        id: "m1",
        nombre: "Módulo 1. Fundamentos",
        cuestionarios: [
          {
            id: "q-etica-01",
            tipo: "NORMATIVO",
            nombre: "Ciberseguridad",
            version: 2025,
            fechaCreacion: "10/1/2025 10:19:41 AM",
          },
          {
            id: "q-etica-02",
            tipo: "NORMATIVO",
            nombre: "Código de Conducta en el Mercado de Valores (CCMV)",
            version: 2025,
            fechaCreacion: "9/22/2025 9:56:39 AM",
          },
          {
            id: "q-etica-03",
            tipo: "NORMATIVO",
            nombre: "Cultura de Riesgos",
            version: 2025,
            fechaCreacion: "9/26/2025 10:43:10 AM",
          },
          {
            id: "q-etica-04",
            tipo: "NORMATIVO",
            nombre: "FATCA & CRS",
            version: 2025,
            fechaCreacion: "9/22/2025 1:09:46 PM",
          },
          {
            id: "q-etica-05",
            tipo: "NORMATIVO",
            nombre: "FX GLOBAL CODE",
            version: 2025,
            fechaCreacion: "9/22/2025 1:30:24 PM",
          },
        ],
      },
      {
        id: "m2",
        nombre: "Módulo 2. Aplicación práctica",
        cuestionarios: [
          {
            id: "q-etica-06",
            tipo: "NORMATIVO",
            nombre: "Manual de Conducta (Código de ética)",
            version: 2025,
            fechaCreacion: "9/22/2025 11:34:57 AM",
          },
          {
            id: "q-etica-07",
            tipo: "NORMATIVO",
            nombre: "Partes Relacionadas",
            version: 2025,
            fechaCreacion: "9/22/2025 1:57:55 PM",
          },
          {
            id: "q-etica-08",
            tipo: "NORMATIVO",
            nombre: "Plan de Continuidad de Negocio",
            version: 2025,
            fechaCreacion: "10/28/2025 7:31:04 PM",
          },
          {
            id: "q-etica-09",
            tipo: "NORMATIVO",
            nombre: "PLD CFT",
            version: 2025,
            fechaCreacion: "10/1/2025 4:45:53 PM",
          },
          {
            id: "q-etica-10",
            tipo: "NORMATIVO",
            nombre: "Prácticas de Venta",
            version: 2025,
            fechaCreacion: "10/1/2025 1:25:26 PM",
          },
        ],
      },
    ],
  },
  {
    id: "curso-ciber",
    titulo: "Ciberseguridad para Usuarios",
    resumen: "Buenas prácticas en el uso de tecnología corporativa.",
    estado: "En curso",
    modulos: [
      {
        id: "m1",
        nombre: "Módulo 1. Correo y contraseñas",
        cuestionarios: [
          {
            id: "q-ciber-01",
            tipo: "OPERATIVO",
            nombre: "Correos sospechosos",
            version: 2025,
            fechaCreacion: "9/15/2025 9:30:00 AM",
          },
          {
            id: "q-ciber-02",
            tipo: "OPERATIVO",
            nombre: "Gestión de contraseñas",
            version: 2025,
            fechaCreacion: "9/16/2025 11:05:00 AM",
          },
        ],
      },
      {
        id: "m2",
        nombre: "Módulo 2. Navegación segura",
        cuestionarios: [
          {
            id: "q-ciber-03",
            tipo: "OPERATIVO",
            nombre: "Navegación en sitios web",
            version: 2025,
            fechaCreacion: "9/18/2025 3:10:00 PM",
          },
        ],
      },
    ],
  },
];

// --- Helpers ---

export function getQuestionnaireCourses() {
  return questionnaireCourses.map((c) => ({
    id: c.id,
    titulo: c.titulo,
    resumen: c.resumen,
    estado: c.estado,
    totalModulos: c.modulos.length,
    totalCuestionarios: c.modulos.reduce(
      (acc, m) => acc + m.cuestionarios.length,
      0
    ),
  }));
}

export function getCourseWithQuizzes(courseId) {
  return questionnaireCourses.find((c) => c.id === courseId) || null;
}

export function getFlattenedQuizzesByCourse(courseId) {
  const course = getCourseWithQuizzes(courseId);
  if (!course) return [];
  const items = [];
  course.modulos.forEach((m) => {
    m.cuestionarios.forEach((q) => {
      items.push({
        ...q,
        moduloId: m.id,
        moduloNombre: m.nombre,
        courseId: course.id,
        courseTitle: course.titulo,
      });
    });
  });
  return items;
}
